import { PesticideMap } from "widgets/pesticideMap"

export const PesticideMapPage = () => {
  return <PesticideMap />
}